import React, { useState, useEffect } from "react";
import clsx from 'clsx';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { unstable_useTreeItem2 as useTreeItem2 } from '@mui/x-tree-view/useTreeItem2';
import {
    makeStyles,
    ThemeProvider,
} from "@mui/styles";
import {
    TreeItem2Content,
    TreeItem2IconContainer,
    TreeItem2GroupTransition,
    TreeItem2Label,
    TreeItem2Root,
} from '@mui/x-tree-view/TreeItem2';
import { TreeItem2Icon } from '@mui/x-tree-view/TreeItem2Icon';
import { TreeItem2Provider } from '@mui/x-tree-view/TreeItem2Provider';
import OverflowTip from "./OverflowTip";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ElectricMeterIcon from '@mui/icons-material/ElectricMeter';
import SpeedIcon from '@mui/icons-material/Speed';
import WifiIcon from '@mui/icons-material/Wifi';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import PowerIcon from '@mui/icons-material/Power';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import WindPowerIcon from '@mui/icons-material/WindPower';
import ComputerIcon from '@mui/icons-material/Computer';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import DeleteIcon from "@mui/icons-material/Delete";
import { planitemiconData } from "variables/MBM/lists/geb";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';


const useTreeItemStyles = makeStyles((theme) => ({
    root: {
        // marginTop: "5px !important",
        color: "var(--tree-view-uneselected-color)",
        "&:hover > $content": {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        "&:focus > $content, &$selected > $content": {
            backgroundColor: "#636363",
            color: "var(--tree-view-color)",
        },
        "&$selected > $content": {
            backgroundColor: "#636363",
            color: "var(--tree-view-color)",
        },
    },
    treeGrid: {
        padding: "0 15px 0 7px",
    },
    content: {
        color: "var(--tree-view-uneselected-color)",
        //borderTopRightRadius: '16px',
        //borderBottomRightRadius: '16px',
        paddingRight: '8px',
        paddingLeft: 0,
        fontWeight: 500,
        "$expanded > &": {
            fontWeight: 400,
        },
    },
    group: {
        marginLeft: "6px",
        //'& $content': {
        //    paddingLeft: '16px',
        //},
    },
    expanded: {},
    selected: {
        "&:focus > $content, &$selected > $content": {
            backgroundColor: "#636363",
            color: "#fafafa",
        },
        "&$selected > $content": {
            backgroundColor: "#91C73C",
            color: "#fafafa",
        },
    },
    label: {
        fontWeight: "bold",
        backgroundColor: "transparent !important",
        paddingLeft: "0px",
    },
    labelRoot: {
        //display: "-webkit-inline-box",
        display: "flex",
        alignItems: "center",
        padding: "0px 0px 0px 0px",
        width: "100%",
        minWidth: "0",
        justifyContent: "space-between",
        alignItems: "center",
        "&:hover > $labelActions": {
            transition: "opacity 500ms",
            opacity: "0.7"
        },
        "&:focus > $labelActions": {
            opacity: "0.7"
        },
        "&$selected > $labelActions": {
            opacity: "0.7"
        }
    },
    labelIcon: {
        marginRight: "6px",
        //   color: "#ffffff",
        fontSize: "1.2rem !important",
        width: "15px",
        height: "15px",
    },
    labelText: {
        fontWeight: "normal",
        fontFamily: '"Source Sans Pro",sans-serif',
        flexGrow: 1,
        fontSize: "0.83rem",
        paddingTop: "4px",
        whiteSpace: "nowrap",
        // maxWidth: "160px",
        // overflow: "hidden",
        // textOverflow: "ellipsis",
    },
    labelTextInactive: {
        fontWeight: "normal",
        fontFamily: '"Source Sans Pro",sans-serif',
        flexGrow: 1,
        fontSize: "0.83rem",
        paddingTop: "4px",
        whiteSpace: "nowrap",
        fontStyle: "italic",
        // maxWidth: "160px",
        // overflow: "hidden",
        // textOverflow: "ellipsis",
    },
    labelViewdataIcon: {
        marginRight: "6px",
        //   color: "#ffffff",
        fontSize: "1.2rem !important",
        width: "15px",
        height: "15px",
    },
    labelTitle: {
        display: "flex",
        alignItems: "center",
    },
    labelActions: {
        opacity: "0",
        display: "flex",
        alignItems: "center",
    }
}));

const CustomTreeItemContent = styled(TreeItem2Content)(({ theme }) => ({
    padding: '4px 8px',
    fontWeight: 500,
    "$expanded > &": {
        fontWeight: 400,
    },
    "&:hover": {
        backgroundColor: "rgba(80, 80, 80, 0.08)",
    },
    [`&.AVOB-searched`]: {
        color: "#91c241"
    },
    [`&.Mui-selected`]: {
        backgroundColor: "rgb(145 199 60 / 50%)",
        color: "rgb(0 0 0 / 80%)"
    }
}));
const StyledTreeItemRoot = styled(TreeItem2Root)(({ theme }) => ({
    // marginTop: "5px !important",
    paddingTop: 0,
    [`& .MuiCollapse-root`]: {
        paddingLeft: 5,
        marginLeft: 0,
    },
    color: "var(--tree-view-uneselected-color)",
    "&:hover > $content": {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    "&:focus > $content, &$selected > $content": {
        backgroundColor: "#636363",
        color: "var(--tree-view-color)",
    },
    "&$selected > $content": {
        backgroundColor: "#636363",
        color: "var(--tree-view-color)",
    },
}));

const getTreeIcon = (icon) => {
    let iconret = "";
    if (icon === 'electricmeter')
        return ElectricMeterIcon;
    else if (icon === 'electricbolt')
        return ElectricBoltIcon;
    else if (icon === 'power')
        return PowerIcon;
    else if (icon === 'wifi')
        return WifiIcon;
    else if (icon === 'acunit')
        return AcUnitIcon;
    else if (icon === 'speed')
        return SpeedIcon;
    else if (icon === 'lightbulb')
        return LightbulbIcon;
    else if (icon === 'windpower')
        return WindPowerIcon;
    else if (icon === 'computer')
        return ComputerIcon;
    else if (icon === 'heat')
        return LocalFireDepartmentIcon;
    return iconret;
}
const getIcon = (icon) => {
    let iconret = QuestionMarkIcon;
    iconret = planitemiconData.find((item) => item.id === icon)?.icon || QuestionMarkIcon;
    return iconret;
}

export default function MeteringPlanTree(props) {
    const { items, viewitemdata, editionmode, edititem, selectionmode, selected, setSelected, deleteitem } = props;

    const [expanded, setExpanded] = useState(props.expanded || []);
    const classesTreeItem = useTreeItemStyles();

    useEffect(() => {
        if (props.selected) {
            let expandedtmp = [];
            defineExpanded(items, expandedtmp);
            setExpanded(expandedtmp);
        }
    }, [items]);

    const defineExpanded = (treenode, expandednodes) => {
        let expandfather = false;
        treenode.forEach((item) => {
            let expanded = false;
            if (selected === item.id) {
                expanded = true;
            }
            let expandedbychildren = false;
            if (item.children && item.children.length > 0)
                expandedbychildren = defineExpanded(item.children, expandednodes);
            if (expandedbychildren)
                expandednodes.push(item.id);
            if (expanded || expandedbychildren)
                expandfather = true;
        });
        return expandfather;
    }

    const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
        const { id, itemId, label, disabled, children, ...other } = props;

        const {
            getRootProps,
            getContentProps,
            getIconContainerProps,
            getLabelProps,
            getGroupTransitionProps,
            status,
            publicAPI,
        } = useTreeItem2({ id, itemId, children, label, disabled, rootRef: ref });
        let item = publicAPI.getItem(itemId);
        let LabelIcon = getIcon(item.icon);

        return (
            <TreeItem2Provider itemId={itemId}>
                <StyledTreeItemRoot {...getRootProps(other)}>
                    <CustomTreeItemContent {...getContentProps({
                        className: clsx('content', {
                            'Mui-expanded': status.expanded,
                            'Mui-selected': status.selected,
                            'Mui-focused': status.focused,
                            'Mui-disabled': status.disabled,
                        }),
                    })}>
                        <TreeItem2IconContainer {...getIconContainerProps()} className="avobtreeicon">
                            <TreeItem2Icon status={status} />
                        </TreeItem2IconContainer>
                        <div className={classesTreeItem.labelRoot}>
                            <div className={classesTreeItem.labelTitle}>
                                {item.icon ? <LabelIcon color={item.iconcolor} className={classesTreeItem.labelIcon} /> : <></>}
                                <Typography variant="body2" className={item.inactive ? classesTreeItem.labelTextInactive : classesTreeItem.labelText}>
                                    <OverflowTip value={label} someLongText={label} />
                                </Typography>
                            </div>
                            {
                                !selectionmode ?
                                    <div className={classesTreeItem.labelActions}>
                                        {
                                            (item.valuetype === 'point' || item.valuetype === 'agg')? 
                                            <VisibilityIcon color={"#91C73C"} className={classesTreeItem.labelViewdataIcon} onClick={(event) => viewitemdata(item)}></VisibilityIcon>
                                            :<></>
                                        }
                                        
                                        {
                                            editionmode ?
                                                <EditIcon color={"#91C73C"} className={classesTreeItem.labelViewdataIcon} onClick={(event) => edititem(item)}></EditIcon>
                                                : <></>
                                        }
                                        {
                                            (editionmode && !children)?
                                                <DeleteIcon color={"#91C73C"} className={classesTreeItem.labelViewdataIcon} onClick={(event) => deleteitem(item)}></DeleteIcon>
                                                : <></>
                                        }
                                    </div> : <></>
                            }

                        </div>
                    </CustomTreeItemContent>
                    {children && (
                        <TreeItem2GroupTransition {...getGroupTransitionProps()} />
                    )}
                </StyledTreeItemRoot>
            </TreeItem2Provider>
        );
    });


    return (
        <Box sx={{ minHeight: 180, flexGrow: 1, maxWidth: 300 }}>
            <RichTreeView
                aria-label="icon expansion"
                items={props.items}
                slots={{ item: CustomTreeItem }}
                onExpandedItemsChange={(event, itemIds) => {
                    event.persist();
                    const iconClicked = event.target
                        .closest('div')
                        .matches('[class*="avobtreeicon"]');
                    if (iconClicked) {
                        setExpanded(itemIds);
                    }
                }}
                expandedItems={expanded}
                multiSelect={false}
                selectedItems={selected}
                onSelectedItemsChange={(event, ids) => {
                    event.persist();
                    const iconClicked = event.target
                        .closest('div')
                        .matches('[class*="avobtreeicon"]');
                    if (!iconClicked) {
                        if (ids) {
                            setSelected(ids);
                        }
                    }
                }}
            />
        </Box>
    );
}